/** @format */

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';

import { store } from './core/store';
import App from './core/App';
import * as serviceWorker from './serviceWorker';

import i18n from './core/i18n';

import 'assets/scss/material-dashboard-pro-react.scss?v=1.5.0';
import { SnackbarProvider } from 'notistack';
import COLORS from './assets/themes/OPL/colors';
import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
    createStyles({
        success: { backgroundColor: COLORS.FUNCTION.SUCCESS, fontFamily: '"Helvetica 55 Roman", "Helvetica 75", "Arial"' },
        error: { backgroundColor: COLORS.FUNCTION.DANGER, fontFamily: '"Helvetica 55 Roman", "Helvetica 75", "Arial"' },
        warning: { backgroundColor: COLORS.FUNCTION.WARNING, fontFamily: '"Helvetica 55 Roman", "Helvetica 75", "Arial"' },
        info: { backgroundColor: COLORS.FUNCTION.INFO, fontFamily: '"Helvetica 55 Roman", "Helvetica 75", "Arial"' },
    })
);

const SnackbarProviderHOC = (props) => {
    const classes = useStyles();

    return (
        <SnackbarProvider
            maxSnack={8}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            classes={{
                variantSuccess: classes.success,
                variantError: classes.error,
                variantInfo: classes.info,
                variantWarning: classes.warning,
            }}
        >
            {props.children}
        </SnackbarProvider>
    );
};

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <Provider store={store}>
            <SnackbarProviderHOC>
                <Suspense fallback="">
                    <App />
                </Suspense>
            </SnackbarProviderHOC>
        </Provider>
    </I18nextProvider>,
    document.getElementById('root')
);
serviceWorker.unregister();
